import React from 'react'
import "./services.css";
import Image1 from "../../assets/back-end.png";
import Image2 from "../../assets/frontEnd.png";
import Image3 from "../../assets/fullstack.png";
import { useLanguage } from '../../context/LanguageContext';

const createData = (translations) => [
  {
    id: 1,
    image: Image1,
    title: "Backend",
    description:
      "▪️ Java; ▪️ Spring; ▪️ Microsserviços; ▪️ Python",
  },
  {
    id: 2,
    image: Image2,
    title: "Frontend",
    description:
      "▪️ HTML ▪️ CSS ▪️ JavaScript; ▪️ Angular; ▪️ React",
  },
  {
    id: 3,
    image: Image3,
    title: translations.toolsTitle,
    description:
      "▪️ SQL; ▪️ JIRA ▪️ Confluence; ▪️ Git ▪️ Bitbucket; ▪️ Airflow ▪️ AWS; ▪️ Metodol. Ágeis: SCRUM e Kanban;",
  },
];


const Services = () => {
  const { translations } = useLanguage();
    
  const data = createData(translations);

  const createMarkup = (html) => {
    return { __html: html };
  };

  return (
  <section className="services container section" id="services">
    <h2 className="section__title">{translations.servicesTitle}</h2>

    <div className="services__container grid">
      {data.map(({id, image, title, description}) => {
        return (
          <div className="services__card" key={id}>
            <img src={image} alt="" className="services__img" />
          
            <h3 className="services__title">{title}</h3>
            <div className="services__description">
                {description.split(';').map((line, index) => (
                  <p key={index} dangerouslySetInnerHTML={createMarkup(line.trim())}></p>
                ))}
              </div>
          </div>
        )
      })}
    </div>
  </section>
  );
}

export default Services